import { useMutation, useQuery } from '@tanstack/react-query';
import { resolverApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack line-user-id-resolver
 * @graph-domain Marketing, Operations
 * @graph-business 利用可能 LINE 公式アカウント一覧を取得するフック
 * @graph-connects resolverApi.getAccounts [calls] /line-user-id-resolver/accounts API
 */
export function useLineOfficialAccounts() {
  return useQuery({
    queryKey: queryKeys.resolver.accounts(),
    queryFn: resolverApi.getAccounts,
  });
}

/**
 * @graph-stack line-user-id-resolver
 * @graph-domain Marketing, Operations
 * @graph-business resolve mutation。CSV と対象アカウントを送信して reveal ペアを受け取る。レスポンスは TanStack Query mutation の戻り値としてのみ存在し、Query キャッシュには保管されない（mutation は cacheTime/gcTime の対象外）
 * @graph-connects resolverApi.resolve [calls] POST /line-user-id-resolver/resolve
 */
export function useResolve() {
  return useMutation({
    mutationFn: resolverApi.resolve,
  });
}

/**
 * @graph-stack line-user-id-resolver
 * @graph-domain Marketing, Operations
 * @graph-business profile lookup mutation。単一 line_user_id について LINE プロフィール + arthur 連携 + aircloset 会員サマリを取得する。レスポンスは TanStack Query mutation の戻り値としてのみ存在し、Query キャッシュには保管されない
 * @graph-connects resolverApi.lookupProfile [calls] POST /line-user-id-resolver/profile
 */
export function useLookupProfile() {
  return useMutation({
    mutationFn: resolverApi.lookupProfile,
  });
}
